import styled from "styled-components";

export const StyledEmptyState = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    height: 100px;
    width: 100px;
  }

  @media (min-width: ${(props) => props.theme.query.md.maxWidth}px) {
    svg {
      height: 130px;
      width: 130px;
    }
  }
`;

export const StyledEmptyStateText = styled.div`
  width: 140px;
  text-align: center;
  font-weight: ${(props) => props.theme.figma.base.scale_70};
  font-size: ${(props) =>
    props.theme.mixins.pxToRem(props.theme.figma.base.scale_2)};
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};

  @media (min-width: ${(props) => props.theme.query.md.maxWidth}px) {
    width: 220px;
    font-size: ${(props) =>
      props.theme.mixins.pxToRem(props.theme.figma.base.scale_3)};
  }
`;
